import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.object.to-string.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionnaireFlow',
  props: {
    sections: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    itemText: {
      type: String,
      default: 'label'
    },
    // Optional: allow parent to control the selected section id (string or function)
    selectedSectionId: {
      type: [String, Function],
      default: undefined
    },
    // Optional: allow parent to control how navigation updates the route
    updateRoute: {
      type: Function,
      default: undefined
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var route = useRoute();
    var router = useRouter();
    // Resolve selected section id in order of precedence:
    // 1) Explicit prop (string or function)
    // 2) Query param `step`
    // 3) Fallback to current route path
    var resolvedSelectedSectionId = computed(function () {
      var provided = props.selectedSectionId;
      var providedValue = typeof provided === 'function' ? provided() : provided;
      return providedValue || route.query.step || route.path;
    });
    var activeTab = ref([resolvedSelectedSectionId.value]);
    var _findOpenSections = function findOpenSections(id, sections) {
      if (!sections) return [];
      var _iterator = _createForOfIteratorHelper(sections),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var section = _step.value;
          if (section.id === id) {
            return [section.id];
          }
          var pathInSubsections = _findOpenSections(id, section.sections);
          if (pathInSubsections.length > 0) {
            return [String(section.id)].concat(_toConsumableArray(pathInSubsections));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return [];
    };
    var open = ref(_findOpenSections(resolvedSelectedSectionId.value, props.sections));
    var _flatten = function flatten(sections) {
      var allSections = [];
      var _iterator2 = _createForOfIteratorHelper(sections),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var section = _step2.value;
          allSections.push(section);
          if (section.sections) {
            var _iterator3 = _createForOfIteratorHelper(_flatten(section.sections)),
              _step3;
            try {
              var _loop = function _loop() {
                var subsection = _step3.value;
                if (!allSections.find(function (e) {
                  return e.id === subsection.id;
                })) {
                  allSections.push(subsection);
                }
              };
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return allSections;
    };
    var flatsections = computed(function () {
      return _flatten(props.sections);
    });
    var sectionIndex = computed(function () {
      return flatsections.value.findIndex(function (e) {
        return e.id === resolvedSelectedSectionId.value;
      }) || 0;
    });
    var selectedSection = computed(function () {
      var _flatsections$value;
      return (_flatsections$value = flatsections.value) === null || _flatsections$value === void 0 ? void 0 : _flatsections$value[sectionIndex.value];
    });
    var isIntro = computed(function () {
      return sectionIndex.value === 0;
    });
    var isOutro = computed(function () {
      var _flatsections$value2;
      return sectionIndex.value + 1 === ((_flatsections$value2 = flatsections.value) === null || _flatsections$value2 === void 0 ? void 0 : _flatsections$value2.length);
    });
    var onUpdateActive = function onUpdateActive(active) {
      if (active && active.length > 0) {
        var _selectedSection = flatsections.value.find(function (s) {
          return s.id === active[0];
        });
        // Only allow navigation if the section is not skipped
        if (_selectedSection && !_selectedSection.skip) {
          activeTab.value = active;
          if (props.updateRoute) {
            props.updateRoute(String(active[0]));
          } else {
            router.push(active[0]);
          }
        } else {
          // Reset active to previous value if section shouldn't be activated
          activeTab.value = [resolvedSelectedSectionId.value];
        }
      }
    };
    var _navigateFromSection = function navigateFromSection(index, steps) {
      var nextIndex = index + steps;
      var section = flatsections.value[nextIndex];
      if (!section) return;
      if (section.skip) {
        // if the section content should be skipped, we navigate to the next or previous section, depending on the direction we were going already
        var nextStep = steps < 0 ? -1 : +1;
        _navigateFromSection(nextIndex, nextStep);
        return;
      }
      var id = section.id;
      activeTab.value = [id];
      open.value = _findOpenSections(id, props.sections);
      if (props.updateRoute) {
        props.updateRoute(String(id));
      } else {
        router.push(id);
      }
    };
    var nextSection = function nextSection() {
      _navigateFromSection(sectionIndex.value, 1);
    };
    var previousSection = function previousSection() {
      _navigateFromSection(sectionIndex.value, -1);
    };
    watch(function () {
      return route.fullPath;
    }, function () {
      var newId = resolvedSelectedSectionId.value;
      activeTab.value = [newId];
      open.value = _findOpenSections(newId, props.sections);
    });
    watch(function () {
      return props.sections;
    }, function (newSections) {
      if (!newSections) return;
      var id = resolvedSelectedSectionId.value;
      activeTab.value = [id];
      open.value = _findOpenSections(id, newSections);
    }, {
      deep: true,
      immediate: true
    });
    return {
      __sfc: true,
      props: props,
      route: route,
      router: router,
      resolvedSelectedSectionId: resolvedSelectedSectionId,
      activeTab: activeTab,
      findOpenSections: _findOpenSections,
      open: open,
      flatten: _flatten,
      flatsections: flatsections,
      sectionIndex: sectionIndex,
      selectedSection: selectedSection,
      isIntro: isIntro,
      isOutro: isOutro,
      onUpdateActive: onUpdateActive,
      navigateFromSection: _navigateFromSection,
      nextSection: nextSection,
      previousSection: previousSection
    };
  }
});